module.exports = __webpack_public_path__ + "media/images/sp/stores/suns/studio-suns_spot_03-17619886e757c2065e2d3a3e0c379424.jpg";